import { RouteType } from "types/RouteType";
import ProductRoute from "./Product.Route";
import productCategoriesRoute from "./ProductCategories/ProductCategories.Route";
import productManagementRoute from "./ProductManagement/ProductManagement.Route";
import productDrawingManagementRoute from "./DrawingManagement/DrawingManagement.Route";

/**
 * Product Management Routes List
 */
const productRoutesList: RouteType[] = [
  ProductRoute,
  productCategoriesRoute,
  productManagementRoute,
  productDrawingManagementRoute,
];

export default productRoutesList;
